module.exports = __webpack_public_path__ + "img/ch67.26be3c38.png";